import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import styles from './styles.scss';

const Upsell = (props) => {
  const type = props.type.toLowerCase();
  const TYPES = {
    RIDE: 'ride',
    RUN: 'run'
  };
  if (type !== TYPES.RIDE && type !== TYPES.RUN) {
    return null;
  }
  return (
    <div className={styles.upsellContainer}>
      <h3>
        {I18n.t(
          `strava.activities.show_public.${
            type === TYPES.RIDE ? 'segments' : 'splits'
          }`
        )}
      </h3>
      <div className={`${styles.upsellWrapper} ${styles[type]}`}>
        <div className={styles.content}>
          <a
            href="/register"
            onClick={() =>
              trackV2({
                ...props.analyticsData,
                element: `sign_up_${type}`,
                action: 'click'
              })
            }
          >
            <span className="app-icon icon-locked" />
            {/* TODO: Update with translation key */}
            <b>Sign up</b> to see these details and more
          </a>
        </div>
      </div>
    </div>
  );
};

Upsell.propTypes = {
  type: PropTypes.string.isRequired,
  analyticsData: PropTypes.shape().isRequired
};

export default Upsell;
